// Utilities
import { createSimpleFunctional } from "../../util/index.mjs";
export const VPickerTitle = createSimpleFunctional('v-picker-title');
//# sourceMappingURL=VPickerTitle.mjs.map